import Http from '@nal/helpers/http';
import { Observable } from 'rxjs';
import { AbstractBaseService } from '@nal/services/AbstractBase.service';

export class BaseService extends AbstractBaseService {
    protected resourceUrl: string;

    constructor(resourceUrl: string) {
        super();
        this.resourceUrl = resourceUrl;
    }

    index(
        page: number = 0,
        perPage: number = 10,
        filters: any = {},
        includes: string[] = [],
        sorts: any = { id: 'DESC' }
    ): Observable<any> {
        const url = `${this.resourceUrl}?filters=${JSON.stringify(filters)}&includes=${JSON.stringify(
            includes
        )}&sorts=${JSON.stringify(sorts)}&page=${page + 1}&per_page=${perPage}`;
        return Http.get(url);
    }

    destroy(id: number): Observable<any> {
        return Http.delete(`${this.resourceUrl}/${id}`);
    }

    show(id: number, includes: string[] = []): Observable<any> {
        return Http.get(`${this.resourceUrl}/${id}?includes=${JSON.stringify(includes)}`);
    }

    store(payload: any): Observable<any> {
        return Http.post(this.resourceUrl, payload);
    }

    update(id: number, payload: any): Observable<any> {
        return Http.patch(`${this.resourceUrl}/${id}`, payload);
    }
}
